import { render, staticRenderFns } from "./SubQuestionType2.vue?vue&type=template&id=6393145f&scoped=true&"
import script from "./SubQuestionType2.vue?vue&type=script&lang=js&"
export * from "./SubQuestionType2.vue?vue&type=script&lang=js&"
import style0 from "./SubQuestionType2.vue?vue&type=style&index=0&id=6393145f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6393145f",
  null
  
)

export default component.exports